<ng-container *ngIf="items?.length">
    <ng-container *ngFor="let item of items">
        <ng-container [ngTemplateOutlet]="templates[item]"></ng-container>
    </ng-container>
</ng-container>